import { deleteJson, getJson, postJson, putJson } from '@/util/ajaxUtils';
/** 
 * 知识文件夹相关接口
*/
// 上传文件（multipart，返回数据中含上传后的文件 id）
export function knowledgeUpload(file) {
    const formData = new FormData();
    formData.append('file', file);
    return postJson(`/knowledge/file/upload`, { data: formData });
}
//修改文件
export function knowledgeUpdate(data) {
    return postJson(`/knowledge/file/update`, { data });
}
//获取文件列表
export function knowledgeList(data) {
    return postJson(`/knowledge/file/list`, { data });
}
//获取失效文件
export function knowledgeInvalidate(data) {
    return postJson(`/knowledge/file/invalidate`, { data });
}
//新增文件
export function knowledgeAdd(data) {
    return postJson(`/knowledge/file/add`, { data });
}
//删除文件
export function knowledgeDelete(data) {
    return deleteJson(`/knowledge/file/${data}`);
}
/** 
 * 文件夹相关接口
*/
//获取树状文件夹
export function knowledgeTree(data) {
    return getJson(`/knowledge/folder/tree?status=1`, { data });
}
//新增文件夹
export function knowledgeFolderAdd(data) {
    return postJson(`/knowledge/folder/add`, { data });
}
//删除文件夹
export function knowledgeFolderDelete(data) {
    return deleteJson(`/knowledge/folder/${data}`);
}
//修改文件夹
export function knowledgeFolderUpdate(data) {
    return postJson(`/knowledge/folder/update`, { data });
}
// 获取不含根节点的文件夹列表（筛选用）
export function knowledgeFolderListWithoutRoot() {
    return getJson(`/knowledge/folder/list/without-root`);
}
// 全局搜索时获取有效/失效文件数量
export function knowledgeFolderFileCount() {
    return getJson(`/knowledge/folder/file-count`, {});
}

/** 
 * 成员相关接口
*/
//获取成员列表
export function knowledgeMemberList(data) {
    return postJson(`/knowledge/member/list`, { data });
}
//导出成员列表
export function knowledgeMemberExport(data) {
    return getJson(`/knowledge/member/export`, { data });
}

/** 成员批量导入（multipart：FormData，字段名一般为 file；可按后端约定追加 bu 等） */
export function knowledgeMemberImport(formData) {
    return postJson(`/knowledge/member/import`, { data: formData });
}

/** 成员 TA-Tag 批量导入 */
export function knowledgeMemberTaTagImport(formData) {
    return postJson(`/knowledge/member/ta-tag/import`, { data: formData });
}

/** 
 * 字典相关接口
*/
// 字典数据（GET，dictType：如 BU、ta）
export function knowledgeDictionaryList(params) {
    return getJson(`/knowledge/dict-data/data`, { params });
}
// 更新字典数据
export function knowledgeDictionaryUpdate(data) {
    return postJson(`/knowledge/dict-data/update`, { data });
}

/** 日志相关接口 */
//获取日志列表
export function knowledgeLogList(data) {
    return postJson(`/knowledge/log/list`, { data });
}
//导出日志列表
export function knowledgeLogExport(params) {
    return getJson(`/knowledge/log/export`, { params });
}
// 操作模块下拉
export function knowledgeLogOperationModules() {
    return getJson(`/knowledge/log/operation-modules`);
}
// 操作类型下拉（operationModule 传模块 dictValue）
export function knowledgeLogOperationTypes(params) {
    return getJson(`/knowledge/log/operation-types`, { params });
}
// 报告统计概览（卡片数据）
export function knowledgeLogReport(data) {
    return postJson(`/knowledge/log/report`, { data });
}
// 分享次数图表
export function knowledgeLogReportShare(data) {
    return postJson(`/knowledge/log/report/share`, { data });
}

/** 
 * 报告统计
*/
//获取报告统计列表 邮箱发送状态
export function knowledgeReportSendEmailList(data) {
    return postJson(`/knowledge/apply/sendEmail/page`, { data });
}

//邮箱发送状态导出
export function knowledgeReportSendEmailExport(data) {
    return postJson(`/knowledge/apply/sendEmail/export`, { data });
}

//获取审批列表
export function knowledgeApprovalList(data) {
    return postJson(`/knowledge/approval/list`, { data });
}
//导出审批列表
export function knowledgeApprovalExport(data) {
    return postJson(`/knowledge/approval/export`, { data });
}

// 分享记录分页
export function knowledgeSharePage(data) {
    return postJson(`/knowledge/share/page`, { data });
}
// 导出分享记录
export function knowledgeShareExport(data) {
    return postJson(`/knowledge/share/export`, { data });
}

/** TA Tag 管理 */
export function knowledgeTaTagList(data) {
    return postJson(`/knowledge/ta-tag/list`, { data });
}
/** 按 BU 获取 TA Tag 列表（GET，data 为数组） */
export function knowledgeTaTagListByBu(buId) {
    return getJson(`/knowledge/ta-tag/list/by-bu`, { params: { buId } });
}
export function knowledgeTaTagAdd(data) {
    return postJson(`/knowledge/ta-tag/add`, { data });
}
export function knowledgeTaTagUpdate(data) {
    return postJson(`/knowledge/ta-tag/update`, { data });
}
export function knowledgeTaTagDelete(id) {
    return deleteJson(`/knowledge/ta-tag/${id}`);
}

/** BU 权限批量新增 */
export function knowledgePermissionBuBatchAdd(data) {
    return postJson(`/knowledge/permission/bu/batchAdd`, { data });
}

/** 成员 TA Tag 权限更新 */
export function knowledgePermissionTaUpdate(data) {
    return postJson(`/knowledge/permission/ta/update`, { data });
}
